import { ArrowUpRight } from "lucide-react";
import type React from "react";
import { Button } from "@/components/ui/button";
import { ANALYTICS_EVENTS, useAnalytics } from "@/lib/analytics";
import { cn } from "@/lib/utils";

/** Outbound link to a site Lezo builds or runs (Questovery, Vaerdict, Chouic, Simon's profile). */
export function ExternalLinkButton({
	href,
	cta,
	placement,
	variant = "default",
	className,
	children,
}: {
	href: string;
	cta: "questovery" | "vaerdict" | "chouic" | "founder";
	placement: string;
	variant?: "default" | "outline";
	className?: string;
	children: React.ReactNode;
}) {
	const { capture } = useAnalytics();

	return (
		<Button
			variant={variant}
			size="lg"
			className={cn(
				"group/ext h-auto min-h-11 rounded-lg px-6 py-2.5 font-mono text-[13px] whitespace-normal has-[>svg]:px-6",
				className,
			)}
			asChild
		>
			<a
				href={href}
				target="_blank"
				rel="noopener"
				onClick={() =>
					capture(ANALYTICS_EVENTS.ctaClick, { cta, placement, href })
				}
			>
				{children}
				<ArrowUpRight className="transition-transform duration-300 ease-(--ease-soft) group-hover/ext:translate-x-0.5 group-hover/ext:-translate-y-0.5" />
			</a>
		</Button>
	);
}
